import BrowserStorage from './browser-storage';
import InMemoryStorageCache from './in-memory-storage';
import AbstractModuleFactory from '@core/shared/module-factory';

export type StorageTypes = 'local' | 'session';
export interface ICache {
  clear(): Promise<void>;
  removeItem(key: string): Promise<void>;
  setItem(key: string, payload: any): Promise<void>;
  getItem(path: string, defaultValue?: any): Promise<Nullable<string>>;
}

/**
 * ### StorageFactory module dependency factory.
 * Abstract Factory that create instance for for in-memory
 * or for local Storages.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
class StorageAbstractFactory extends AbstractModuleFactory {
  public defineGlobalStorage(type: StorageTypes = 'local'): void {
    sessionStorage.clear();
    console.log('Setting Storage: ', type);

    sessionStorage.setItem('global-storage', type);
  }

  public getGlobalType(): StorageTypes {
    return (sessionStorage.getItem('global-storage') ?? 'local') as StorageTypes;
  }

  public getSyncGlobalInstance(): Storage {
    const globalStorageType: StorageTypes = this.getGlobalType();
    if (globalStorageType === 'session') return window.sessionStorage;
    else return window.localStorage;
  }

  public getAsyncGlobalInstance(): ICache {
    const globalStorageType: StorageTypes = this.getGlobalType();
    if (globalStorageType === 'local') return this.createLocalStorage();
    else if (globalStorageType === 'session') return this.createSessionStorage();
    return this.createInMemoryStorage();
  }

  createSessionStorage(): ICache {
    return this.ensureInstance('session', () => new BrowserStorage());
  }

  createInMemoryStorage(): ICache {
    return this.ensureInstance('in-memory', () => new InMemoryStorageCache());
  }

  createLocalStorage(): ICache {
    return this.ensureInstance('local', () => new BrowserStorage());
  }

  static new(): StorageAbstractFactory {
    return new StorageAbstractFactory();
  }
}

export default StorageAbstractFactory.new();
